import { httpServer } from './axios.js'

let zsUrl =
window.document.domain == 'xyqw.xinyuanhulian.com' ?'https://admission.xinyuanhulian.com/v1/api/': 'https://admission.xinyuanhulian.com/v1/api/'
const caiwuUrl =
  window.document.domain === 'xyqw.xinyuanhulian.com'? 'https://finance.xinyuanhulian.com/caiwu/v1/api/' : 'https://finance.xinyuanhulian.com/caiwu/v1/api/'

let tuwenUrl =
window.document.domain == 'xyqw.xinyuanhulian.com' ? 'http://qf-gw.1000phone.com/api/graphic/': 'http://test-qf-gw.1000phone.com/api/graphic/'

let xlyUrl = window.document.domain == 'xyqw.xinyuanhulian.com' ?'http://www.qfzxk.com/sns/': 'http://livebroad.1000phone.net/sns/'

export const chatauthurl = (obj) => {
  // 获取验证码
  return httpServer('get', 'wxAuthmobile/api/authurl', obj, {})
}

export const wxLogin = (obj) => {
  // 登录
  return httpServer('get', `wxAuthmobile/api/login/${obj.code}`, {}, {})
}

export const grouplist = (obj) => {
  // B站列表
  return httpServer('post', 'wespeechcraftmobile/groupList', {}, obj)
}

export const wespeechcraftmobile = (obj) => {
  return httpServer('post','wespeechcraftmobile/list',{}, obj)
}

export const config = (obj) => {
  return httpServer('post','wxAuthmobile/api/config',{}, obj)
}

export const AgentConfigUrl = (obj) => {
  return httpServer('post','wxAuthmobile/api/agentConfig',{}, obj)
}

export const queryMediaId = (obj) => {
  return httpServer('post', `wespeechcraftmobile/queryMediaId/${obj.id}`, {}, obj)
}

export const infoList = (obj) => {
  return httpServer('get', `weqrcode/info/${obj.id}`, {}, {})
}

export const bilishareadminUpdate = (obj) => {
  // 获取分享url
  return httpServer('post', 'bilishareadmin/update', {}, obj)
}

export const zhilianglist = (obj) => {
  return httpServer('post', 'personas/api/zhilianglist', {}, obj)
}

//学员画像获取信息
export const getUserInfo = (obj) => {
  return httpServer('post', 'personas/api/getUserInfo', {}, obj)
}

export const documentaryRecord = (obj) => {
  return httpServer('post', `personas/api/documentaryRecord/list/${obj.askId}`, {}, obj)
}

export const updateZhiLiang = (obj) => {
  return httpServer('post', `personas/api/updateZhiLiang/${obj.askId}/${obj.zhiliangID}`, {}, obj)
}

export const tracelist = (obj) => {
  return httpServer('post', 'personas/api/tracelist', {}, obj)
}

//快速跟单提交
export const adddocumentary = (obj) => {
  return httpServer('post', 'personas/api/documentaryRecord/add', {} ,obj)
}

export const sendSms = (obj) => {
  return httpServer('post', `activityxet/sendSms/${obj.tel}`, {}, obj)
}

export const saveuser = (obj) => {
  return httpServer('post', 'wxqyuseruser/save', {}, obj)
}

export function getUserId(obj) {
  return httpServer('get', `activityxet/api/getUserId/${obj.code}`,{},obj)
}

export function wesubject(obj) {
  return httpServer('get', 'wesubject/query', {}, obj)
}

export function addUserInfo(obj) {
  return httpServer('post', 'personas/api/addUserInfo', {}, obj)
}

export function writePhone(obj) {
  return httpServer('post', 'personas/api/addPhone', {}, obj)
}

export function getUserInfoNew(obj) {
  return httpServer('post', 'personasnew/api/getUserInfoNew', {}, obj)
}
export function queryZsStatus(obj) {
  return httpServer('post', `personasnew/api/queryZsStatus/${obj.externalUserId}/${obj.uid}`, {}, obj)
}

export function querexinfo(obj) {
  return httpServer('post', `personasnew/api/querexInfo/${obj.externalUserId}`, {}, obj)
}

export function getWxConfigParam(obj) {
  // 分享接口
  return httpServer('post', `bilishare/config`, {}, obj)
}

export function wepostertypelist(obj) {
  return httpServer('post', 'wepostertype/list', {}, obj)
}

export function wepostermateriallist(obj) {
  return httpServer('post', 'wepostermaterial/list', {}, obj)
}

export function wepostermaterialinfo(obj) {
  return httpServer('get', `wepostermaterial/info/${obj.id}`, {}, obj)
}

export function wepostermaterialbaseinfo(obj) {
  return httpServer('post', 'wepostermaterial/create/baseinfo', {}, obj)
}
export function uploadFile(obj) {
  return httpServer('post', 'updateFile/uploadFile', {}, obj)
}

export function wepostermaterialcreate(obj) {
  return httpServer('post', 'wepostermaterial/create', {}, obj)
}

export function listGroupTag(obj) {
  return httpServer('post', 'tag/corp/listGroupTag', {}, obj)
}

export function corpAddTag(obj) {
  return httpServer('post', 'customer/corp/addTag', {}, obj)
}

export function zsUserInfo(obj) {
  return httpServer('get', `personasnew/api/getZsUserInfo/${obj.uuid}`, {}, obj)
}

export function addTags(obj) {
  return httpServer('post', 'personasnew/api/addTags', {}, obj)
}
export function queryCannal(obj) {
  return httpServer('post', `personasnew/api/queryCannal/${obj.externalUserId}/${obj.uid}`, {}, obj)
}

//企微助手移动端首页
//获取客户总数
export function getCustomerNum(obj) {
  // 分享接口
  return httpServer('get', 'customer/oneDayStats', {},obj)
}
//用户对应菜单权限
export function getCustomerLimit(obj) {
  // 分享接口
  return httpServer('get', `menu/userMobile/${obj.userId}/${obj.superAdmin}`, {},{})
}

//获取客户总数
export function getCurrentCustomer(obj) {
  // 分享接口
  return httpServer('post', 'statistics/userBehavior', {},obj)
}

//客户列表接口
export function getCustomerList(obj) {
  // 分享接口
  return httpServer('post', 'customer/list', {},obj)
}

//企业标签接口
export function getTagList(obj) {
  // 分享接口
  return httpServer('post', 'tag/corp/list', {},obj)
}

//活码列表
export function weqrcodeList(obj) {
  // 分享接口
  return httpServer('post', 'weqrcode/list', {},obj)
}


//活动海报列表
export function playBillList(obj) {
  // 海报列表接口
  return httpServer('post', 'activityxetback/list', {},obj)
}

//活动海报列表
export function playBillQuery(obj) {
  // 海报列表接口
  return httpServer('post', 'activityxetback/query', {},obj)
}

//学科列表
export function subjectQuery() {
  // 海报列表接口
  return httpServer('get', 'wesubject/query', {},{})
}

//海报生成
export function createPlaybill(obj) {
  // 海报列表接口
  return httpServer('get', `activityxet/generate/${obj.id}/${obj.userId}`, {},{})
}

//获取员工列表
export function getUsers(obj) {
  //
  return httpServer('post', 'user/getUserList', {},obj)
}

//客户群发发送
export function wegroupsendSend(obj) {

  return httpServer('get', `wegroupsend/send/{id}/${obj.id}`, {},{})
}

//获取发送人数
export function wegroupsendSendCount(obj) {

  return httpServer('post', 'wegroupsend/sendCount', {},obj)
}

//新建附件保存
export function wegroupsendSave(obj) {

  return httpServer('post', 'wegroupsend/save', {},obj)
}

//新建附件更新
export function wegroupsendUpdate(obj) {

  return httpServer('post', 'wegroupsend/update', {},obj)
}

//潜在客户列表
export function wecustomerpotentialList(obj) {

  return httpServer('post', 'wecustomerpotential/list', {},obj)
}

//潜在客户统计
export function wecustomerpotentialOverview(obj) {

  return httpServer('post', 'wecustomerpotential/overview', {},obj)
}

//潜在客户添加复制号码
export function wecustomerpotentialCopy(obj) {

  return httpServer('post', 'wecustomerpotential/copy', {},obj)
}

//流失客户统计列表
export function lossReminder(obj) {

  return httpServer('post', 'lossReminder/lossReminder', {},obj)
}

export function studentPayYears (obj) {
  return httpServer('post', zsUrl + 'tuitionConfigRestController/getTuitionMonthConfig', {}, obj)
}

export function searchInfo (obj) {
  return httpServer('post', zsUrl + 'reportManagementController/classAvgCount/searchInfo', {}, obj)
}

// 学费查询-选择校区获取学校接口
export function getAllCity (obj) {
  return httpServer('post', zsUrl + 'cityRestController/getAllCity', {}, obj)
}
// 学费查询-选择获取学科接口
export function getcourseAllCourseList (obj) {
  return httpServer('post', zsUrl + 'courseRestController/getAllCourseList', {}, obj)
}

export function selectTuitionConfig(obj) {
  return httpServer('post', zsUrl+'tuitionConfigRestController/selectTuitionConfigListByCondition', {}, obj)
}

export function onlinesubject(obj) {
  return httpServer('post',caiwuUrl+'tuitionSubjectConfigController/selectByNowDay', {}, obj)
}


export function officialinfo(obj) {
  return httpServer('get', `official/info?code=${obj.code}&state=${obj.state}`, {}, obj)
}

//个人话术列表
export const personalProdureList = (obj) => {
  return httpServer('get','wespeechcraftgroup/listQuery',{type:1}, obj)
}

//新建个人话术分组
export function wespeechcraftgroupSaveMobile(obj) {
  return httpServer('post','wespeechcraftgroup/save/mobile', {}, obj)
}

//个人话术分组重命名
export function wespeechcraftgroupUpdateMobile(obj) {
  return httpServer('post','wespeechcraftgroup/update', {}, obj)
}

//新建个人话术保存
export function wespeechcraftSave(obj) {
  return httpServer('post','wespeechcraft/save', {}, obj)
}

//话术更新
export function wespeechcraftUpdate(obj) {
  return httpServer('post','wespeechcraft/update', {}, obj)
}

//編輯回顯话术信息
export function wespeechcraftCheck(obj) {
  return httpServer('get',`wespeechcraft/info/${obj.id}`, {},{})
}

//话术移动分组
export function wespeechcraftRemoveGroupId(obj) {
  return httpServer('post','wespeechcraft/removeGroupId', {}, obj)
}

//删除当前话术
export function wespeechcraftDelete(obj) {
  return httpServer('get',`wespeechcraft/delete/${obj.id}`, {},{})
}

//删除当前话术分组
export function wespeechcraftGroupDelete(obj) {
  return httpServer('get',`wespeechcraftgroup/delete/${obj.id}`, {},{})
}

//个人话术附件部分移动
export function wespeechcraftMmove(obj) {
  return httpServer('post','wespeechcraft/move', {}, obj)
}

//个人话术组移动
export function wespeechcraftgroupMoveGroup(obj) {
  return httpServer('post','wespeechcraftgroup/moveGroup', {}, obj)
}

//个人话术组置顶
export function wespeechcraftgroupTop(obj) {
  return httpServer('post','wespeechcraftgroup/top', {}, obj)
}

//个人话术组取消置顶
export function wespeechcraftgroupTopCancel(obj) {
  return httpServer('post','wespeechcraftgroup/top/cancel', {}, obj)
}

//获取企业人员列表
export function groupSelectUsers(obj) {
  return httpServer('post','group/select/users', {}, obj)
}

//获取企业人员列表
export function groupGetUsers(obj) {
  return httpServer('post','group/getUsers', {}, obj)
}

export function wequesrecordsave(obj) {
  return httpServer('post', 'wequesrecord/save', {}, obj)
}

export function wequesanswersendSms(obj) {
  return httpServer('post', `wequesanswer/sendSms/${obj.tel}`, {}, obj)
}

export function wequesinfo(obj) {
  return httpServer('post', `weques/info/${obj.id}`, {}, obj)
}

export function answersave(obj) {
  return httpServer('post', 'wequesanswer/save', {}, obj)
}

export function answerisSubmit(obj) {
  return httpServer('post', 'wequesanswer/isSubmit', {}, obj)
}

export function answerisAuth(obj) {
  return httpServer('post', 'wequesanswer/isAuth', {}, obj)
}

export function videoListByCourseAndType(obj) {
  return httpServer('post', 'personas/api/getVideoListByCourseAndType', {}, obj)
}

//访问流量采集
export function wefunstatisticsSave(obj) {
  return httpServer('post', 'wefunstatistics/save', {}, obj)
}

//学员录入，来源渠道，咨询师
export function studentQwInitAddForInfoFlow() {
  return httpServer('post', 'student/qwInitAddForInfoFlow', {},)
}

//学员录入提交
export function studentQwAddForInfoFlow(obj) {
  return httpServer('post', 'student/qwAddForInfoFlow', {},obj)
}

//群组活码列表
export function wegrcodeList(obj) {
  return httpServer('post', 'wegrcode/list', {},obj)
}

//群组列表项详情
export function wegrcodeInfo(obj) {
  return httpServer('get', `wegrcode/info/${obj.id}`, {})
}

//学科列表
export function getAllCourseList(obj) {
  return httpServer('post', 'personas/api/getAllCourseList', {},obj)
}

//咨询师
export function getSqAdminListAll(obj) {
  return httpServer('post', 'personas/api/getSqAdminListAll', {},obj)
}

//本地校区下人员
export function weoauserGroupList(obj) {
  return httpServer('post', 'weoauser/groupList', {},obj)
}

//所有校区列表
export function weoauserCityList() {
  return httpServer('get', 'weoauser/cityList', {},)
}

//开班计划列表
export function classList(obj) {
  return httpServer('post', 'class/classList', {},obj)
}

//开班计划班级类型下拉
export function classTypeList() {
  return httpServer('post', 'class/api/classTypeList', {})
}
//学员类型  跟单
export function followOrderType(obj) {
  return httpServer('get', `student/api/zsDic/${obj.id}`, {})
}

/*
* OA资产管理相关接口
* */
//设备编号查询设备
export function machshineInfo(obj) {
  return httpServer('get', `weAssetahaosheng/findAssent/${obj.assetsNo}`, {})
}

//获取员工
export function getAssetsWorker(obj) {
  return httpServer('get', `weAssetahaosheng/getStaff/${obj.cityId}`, {})
}

//获取教室
export function getAssetsRoom(obj) {
  return httpServer('get', `weAssetahaosheng/getStaff2/${obj.cityId}`, {})
}

//教室当下
export function roomStudent(obj) {
  return httpServer('get', `weAssetahaosheng/studentInfo/${obj.roomId}`, {})
}
//入库
export function assetsEnter(obj) {
  return httpServer('post', 'weAssetahaosheng/assentsIn', {},obj)
}

//出库
export function assetsOut(obj) {
  return httpServer('post', 'weAssetahaosheng/assentsOut', {},obj)
}

//三级分类
export function TraceType(partId) {
  return httpServer('post',  `personas/api/studentTraceType/${partId}`, {})
}

//流失学员信息获取
export function getLossUserInfo(obj) {
  return httpServer('post',  `personas/api/getLossUserInfo/${obj.userId}/${obj.tenId}`, {}, obj)
}
//学员分类
export function studentTraceType(obj) {
  return httpServer('post', `personas/api/studentTraceType/${obj.partId}`, {})
}
// 雷达
export function weradarList(obj) {
  return httpServer('post', 'weradar/mobile/select', {}, obj)
}
// 记录
export function readSave(obj) {
  return httpServer('post', `weradarreading/save`, {}, obj)
}

/**
 *  素材库
 */
// 素材库--一级列表
export function materialList(obj) {
  return httpServer('post', `graphic/materialFirst/selectList`, {}, obj)
} 
// 查询素材类型
export function materialTypeList(obj) {
  return httpServer('post', `graphic/materialType/selectList`, {}, obj)
}
// 查询文件类型
export function materialFileList(obj) {
  return httpServer('post', `graphic/fileType/selectList`, {}, obj)
}
// 查询标签组+标签
export function materialLabelList(obj) {
  return httpServer('post', 'graphic/getLabelGroups', {}, obj)
}
// 查询素材
export function getMaterialList(obj) {
  return httpServer('post', `graphic/material/selectList`, {}, obj)
}
// 临时素材上传
export function queryMaterialMediaId(obj) {
  return httpServer('post', `graphic/queryMaterialMediaId`, {}, obj)
}


// 记录
export function weRadarCountVo(obj) {
  return httpServer('post', 'weradarreading/weRadarStatisticsUser',{}, obj)
}

// 加密
export function weRadarEncrypt(obj) {
  return httpServer('post', 'weradar/weRadarEncrypt', {}, obj)
}
// 解密
export function encodeEncrypt(obj) {
  return httpServer('post', 'weradar/weRadarDecrypt', {}, obj)
}
// 查看
export function findId(id) {
  return httpServer('post', `weradar/find/${id}`, {}, {})
}
// 分组
export function selGroup(params) {
  return httpServer('post', 'weradar/mobile/group/select', {}, params)
}

export function labellistSelect(params) {
  return httpServer('post', '/weGroupConfig/select', {}, params)
}


// 训练营海报列表
export function trainPosterList(params) {
  return httpServer('post', xlyUrl + 'course/getPosterList', {}, params)
}
// 训练营海报-获取报名链接
export function trainPosterLink(params) {
  return httpServer('post', xlyUrl + 'course/getJoinLink', {}, params)
}
// 训练营海报-获取智能直播学科列表
export function getCategoryList() {
  return httpServer('get', xlyUrl + 'categroy/getCategoryList', {})
}
// 训练营海报-获取合成的海报
export function getPosterCombineUrl(params) {
  return httpServer('post', xlyUrl + 'course/getPosterCombineUrl', {}, params)
}
